import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Louis Philippe    ",
    description: "Men Maroon Solid Classic Fit Formal Shirt",
    price: 1627,
    original_price: 2200,
    rating: 4.4,
    size: "44",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/17858284/2022/4/27/424bd833-4753-4b4d-9efa-ea35d3c458751651036103573-Louis-Philippe-Men-Shirts-4911651036102998-1.jpg",
    category: "Men's Fashion",
    trending: true,
    reviews: 230,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "HIGHLANDER    ",
    description:
      "Men Grey Tapered Fit Mid-Rise Clean Look Stretchable Jeans    ",
    price: 5499,
    original_price: 6999,
    rating: 4.2,
    size: "34",
    image:
      "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/9162835/2022/8/5/696b0ce4-d90e-4171-b8dc-487b65d1cf7f1659708668573HIGHLANDERMenGreyTaperedFitMid-RiseCleanLookStretchableJeans2.jpg",
    category: "Men's Fashion",
    trending: true,
    reviews: 180,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "HERE&NOW ",
    description: "Men Black Slim Fit Casual Shirt    ",
    price: 649,
    original_price: 799,
    rating: 4.3,
    size: "44",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19818628/2022/9/6/ec27eee6-d613-4423-8e0f-007aea1603c31662468109188Shirts1.jpg",
    category: "Men's Fashion",
    trending: true,
    reviews: 3800,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "The Souled Store    ",
    description: "Men Blue Superman Dyed Oversized T-Shirt    ",
    price: 1049,
    original_price: 1199,
    rating: 4.0,
    size: "XL",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19651286/2023/4/19/ed3caf00-90e0-41b7-a4f9-073a784f9d4b1681903457291-The-Souled-Store-Men-Blue-Superman-Dyed-Oversized-T-Shirt-54-3.jpg",
    category: "Men's Fashion",
    trending: false,
    reviews: 120,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Roadster    ",
    description: "Men Grey Melange Self-Design Pullover    ",
    price: 899,
    original_price: 999,
    rating: 4.1,
    size: "XL",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/14320082/2021/7/21/bb3f0dcc-3b78-4f20-8f98-13179bcad74f1626866476244-Roadster-Men-Sweaters-6221626866475722-1.jpg",
    category: "Men's Fashion",
    trending: true,
    reviews: 320,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Pepe Jeans",
    description: "Men Colourblocked Pure Cotton Mid Rise Shorts    ",
    price: 1494,
    original_price: 2299,
    rating: 4.3,
    size: "30",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19527714/2023/3/29/27164f94-61d8-4eb5-bb86-2f5eb5998d461680091615689-Pepe-Jeans-Men-Black-Colourblocked-Technology-Shorts-9001680-1.jpg",
    category: "Men's Fashion",
    trending: false,
    reviews: 150,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Powerlook",
    description: "Men Organic Cotton Varsity Jacket    ",
    price: 1960,
    original_price: 2499,
    rating: 4.7,
    size: "XL",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/21659222/2023/1/21/81059c97-e7a4-4079-8803-e8a3bd1e14fa1674308118741PowerlookMenBeigeOrganicCottonVarsityJacketwithPatchwork1.jpg",
    category: "Men's Fashion",
    trending: true,
    reviews: 2800,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Reebok",
    description: "Men Black Performance FZ Sporty Jacket",
    price: 2099,
    original_price: 2399,
    rating: 4.5,
    size: "XL",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/18666748/2022/8/25/dcf1f355-d8fc-45cd-9317-722eafb543531661422437979-Reebok-Men-Jackets-5081661422437169-1.jpg",
    category: "Men's Fashion",
    trending: true,
    reviews: 1500,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "KISAH",
    description: "Men Golden & White Kurta Sherwani Set    ",
    price: 5753,
    original_price: 8899,
    rating: 4.4,
    size: "XL",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19631638/2022/9/17/0b6efa28-3bb1-4baa-ac17-ac4ae45241501663410031122KisahMenWhiteKurtaSherwaniSet1.jpg",
    category: "Men's Fashion",
    trending: false,
    reviews: 800,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "House of Pataudi ",
    description:
      "Jashn Mandarin Collar Textured With Embellishment Bandhgala Blazer",

    price: 6499,
    original_price: 9999,
    rating: 3.5,
    size: "44",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/21422316/2023/2/17/275b6290-1f08-479e-a707-642dcd8a59671676614383938-House-of-Pataudi-Men-Blazers-711676614383248-1.jpg",
    category: "Men's Fashion",
    trending: true,
    reviews: 3000,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Lace Bodycon Dress",
    description: "Elegant lace bodycon dress for a night out",
    price: 4899,
    original_price: 5499,
    rating: 4.5,
    size: "S",
    image:
      "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/20636574/2022/11/17/b6634076-c43e-4d1f-aa69-418b12a0840b1668679375250-Berrylush-Women-White-Graphic-Print-Mock-Neck-Bodycon-Dress--1.jpg",
    category: "Women's Fashion",
    trending: true,
    reviews: 360,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Sequin Mini Dress",
    description: "Sparkly sequin mini dress for a glamorous look",
    price: 5599,
    original_price: 6999,
    rating: 4.2,
    size: "M",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/21065898/2022/12/15/f3e0e5f3-c65e-4b80-bbbd-1db44c2682ff1671103620347-MANGO-Women-Dresses-1151671103619683-3.jpg",
    category: "Women's Fashion",
    trending: true,
    reviews: 220,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Wrap Midi Dress",
    description: "Flattering wrap midi dress for a sophisticated style",
    price: 4199,
    original_price: 4599,
    rating: 4.7,
    size: "L",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/17345470/2022/3/2/d8bae4ff-149a-4113-bd0e-6f2edced42501646199504284StyleStoneOrangeFloralCrepeMidiDress1.jpg",
    category: "Women's Fashion",
    trending: false,
    reviews: 180,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Off-Shoulder Maxi Dress",
    description: "Stylish off-shoulder maxi dress for a chic look",
    price: 6299,
    original_price: 6599,
    rating: 4.0,
    size: "S",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19296462/2022/7/29/35babf07-ad85-46a3-8de4-9add0f8792cf1659093698709SHEETALAssociatesGreenOff-ShoulderCrepeMaxiDress1.jpg",
    category: "Women's Fashion",
    trending: false,
    reviews: 140,
    in_stock: true,
    delivery_time: "4-6 business days",
  },
  {
    _id: uuid(),
    title: "Floral Skater Dress",
    description: "Pretty floral skater dress for a feminine touch",
    price: 3499,
    original_price: 4999,
    rating: 4.9,
    size: "M",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/18008000/2022/4/23/b7fcfe89-7a52-4ce5-b68b-fe304d324cf81650722063995PURYSWhiteFloralDress3.jpg",
    category: "Women's Fashion",
    trending: true,
    reviews: 280,
    in_stock: true,
    delivery_time: "1-2 business days",
  },
  {
    _id: uuid(),
    title: "Ruffle Wrap Dress",
    description: "Flouncy ruffle wrap dress for a playful look",
    price: 2799,
    original_price: 2999,
    rating: 4.3,
    size: "S",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/15628304/2021/10/4/4e74e522-9c7d-4617-a410-7aa6708f7d021633340213599URBANICBeigeOffWhitePrintedWrapDress1.jpg",
    category: "Women's Fashion",
    trending: false,
    reviews: 100,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Satin Slip Dress",
    description: "Sleek satin slip dress for a luxurious feel",
    price: 4899,
    original_price: 5299,
    rating: 4.6,
    size: "L",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/21076812/2022/12/22/1bc33459-f0ca-4583-9349-0f82d7f99d851671695243014-Boohoo-Floral-Printed-Cowl-Neck-Satin-Mini-Slip-Dress-511167-1.jpg",
    category: "Women's Fashion",
    trending: true,
    reviews: 320,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Asymmetric Hem Dress",
    description: "Edgy asymmetric hem dress for a unique style",
    price: 4199,
    original_price: 4699,
    rating: 4.4,
    size: "M",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/20707466/2022/11/21/36eae49d-cc02-4a5d-84bc-98459d29b6391669029950517-MANGO-Off-White-Solid-Ruffles-Asymmetric-Hem-A-Line-Midi-Dre-1.jpg",
    category: "Women's Fashion",
    trending: true,
    reviews: 200,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Velvet Wrap Dress",
    description: "Luxurious velvet wrap dress for a glamorous look",
    price: 2599,
    original_price: 2999,
    rating: 4.8,
    size: "S",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22447472/2023/3/28/696af37f-af75-49ca-8bb4-782fad2554151679986562012-Stylecast-X-Hersheinbox-Women-Dresses-4621679986561344-1.jpg",
    category: "Women's Fashion",
    trending: true,
    reviews: 260,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "One-Shoulder Jumpsuit",
    description: "Chic one-shoulder jumpsuit for a trendy style",
    price: 1499,
    original_price: 2199,
    rating: 4.2,
    size: "L",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22427498/2023/3/19/5db63ff0-7c90-4dd0-bad6-306d3d449cef1679165947940Jumpsuit1.jpg",
    category: "Women's Fashion",
    trending: false,
    reviews: 120,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Princess Tutu Dress",
    description: "A beautiful princess tutu dress for kids",
    price: 1099,
    original_price: 1499,
    rating: 4.5,
    size: "S",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/23246272/2023/5/18/bb24a989-f93a-4d00-b779-221e3cfe175d1684394046879ShortSleeveLeotardTutuDress1.jpg",
    category: "Kids' Fashion",
    trending: true,
    reviews: 150,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "A.T.U.N",
    description: "Girl's Polka Dot Dress",
    price: 799,
    original_price: 999,
    rating: 4.2,
    size: "M",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19474342/2022/8/12/ac0ff58e-6148-4ad1-aaf9-c56c81c31ed11660307708542ATUNOffWhiteDress1.jpg",
    category: "Kids' Fashion",
    trending: true,
    reviews: 800,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Noh.Voh - SASSAFRAS Kids",
    description: "Kids Girls Black Crop Sweatshirt",
    price: 749,
    original_price: 999,
    rating: 4.7,
    size: "L",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/20704864/2022/11/18/2e85cb15-48bd-4304-95cb-a0b2565edc941668773067282NohVoh-SASSAFRASKidsGirlsBlackCropSweatshirt1.jpg",
    category: "Kids' Fashion",
    trending: false,
    reviews: 500,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Technosport",
    description: "Boys Antimicrobial Slim Fit T-Shirt",
    price: 449,
    original_price: 799,
    rating: 4.0,
    size: "S",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22548920/2023/3/28/0e62617b-1e52-4601-920b-835a0fee98f61680004122796TechnosportBoysActiveT-shirt1.jpg",
    category: "Kids' Fashion",
    trending: false,
    reviews: 400,
    in_stock: true,
    delivery_time: "4-6 business days",
  },
  {
    _id: uuid(),
    title: "Fabindia",
    description: "Boys Band Collar Striped Straight Cotton Kurta",
    price: 599,
    original_price: 699,
    rating: 4.9,
    size: "M",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22922880/2023/4/27/b1bc8f5d-0e40-47e2-9164-9e83a7e597961682595991293FabindiaBoysWhiteCold-ShoulderSleevesThreadWorkAnarkaliKurta1.jpg",
    category: "Kids' Fashion",
    trending: true,
    reviews: 129,
    in_stock: true,
    delivery_time: "1-2 business days",
  },
  {
    _id: uuid(),
    title: "HRX by Hrithik Roshan",
    description: "Boys Black Printed Rapid Dry Round Neck T-shirt",
    price: 899,
    original_price: 1099,
    rating: 4.3,
    size: "S",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/10565512/2019/12/24/27a5597d-b5a0-4fd1-8eaa-4bf54e8b7f471577168300774-HRX-by-Hrithik-Roshan-Boys-Black-Printed-Rapid-Dry-Round-Nec-1.jpg",
    category: "Kids' Fashion",
    trending: false,
    reviews: 700,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Tiber Taber",
    description:
      "Boys Yellow & Cream-Coloured Printed Pure Cotton Kurta with Dhoti Pants",
    price: 499,
    original_price: 699,
    rating: 4.6,
    size: "M",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16265230/2021/11/27/446cb0d6-e1aa-45b0-acb7-cdaa31cc3c5e1637992151710TiberTaberBoysYellowPrintedRegularPureCottonKurtawithDhotiPa1.jpg",
    category: "Kids' Fashion",
    trending: true,
    reviews: 100,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Pspeaches",
    description:
      "Magenta & White Floral A-Line Cotton Dress with Attached Shrug",
    price: 399,
    original_price: 599,
    rating: 4.4,
    size: "L",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/17045988/2022/2/4/0d9dcffa-936e-4129-a098-e184862a1e9d1643958755775pspeachesMagentaFloralA-LineDress1.jpg",
    category: "Kids' Fashion",
    trending: true,
    reviews: 900,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Aarika",
    description: "Girls Fit and Flare Net Dress",
    price: 749,
    original_price: 999,
    rating: 4.8,
    size: "M",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/21442310/2023/1/6/e623bcbf-5699-4072-b813-d214b739c0551673005499030AarikaYellowNetDress1.jpg",
    category: "Kids' Fashion",
    trending: true,
    reviews: 110,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Fabindia",
    description: "Infant Floral Printed Modal Fit & Flare Dress",
    price: 599,
    original_price: 799,
    rating: 4.2,
    size: "S",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22922682/2023/4/28/c87ad5d4-eacd-49db-a280-1e48dae194801682633836258FabindiaRedFloralPrintFitFlareDress1.jpg",
    category: "Kids' Fashion",
    trending: false,
    reviews: 600,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "LOVE EARTH",
    description: "Set of 9 Liquid Mousse Miniature Matte Lipsticks - 2 ml Each",
    price: 1219,
    original_price: 1699,
    rating: 4.3,
    size: "Pack",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/21180534/2022/12/13/4a47ab9d-5630-4500-9e69-8415ad7f5f6c1670948162199LOVEEARTHLiquidMousseMiniatureSetOf9LiquidMatteLipstick-2mlE1.jpg",
    category: "Beauty",
    trending: true,
    reviews: 253,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Maybelline",
    description: "New York Hypercurl Waterproof Mascara - Black    ",
    price: 699,
    original_price: 999,
    rating: 4.2,
    size: "100ml",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/1967182/2018/7/31/f8e75fd5-47f4-4cc6-946d-cc069773cffb1533030162531-Maybelline-Black-Hyper-Curl-Mascara-Waterproof-Mascara-4211533030162488-1.jpg",
    category: "Beauty",
    trending: true,
    reviews: 300,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "M.A.C    ",
    description: "Set of Lipstick - Eyeliner & Prep + Prime Fix    ",
    price: 5550,
    original_price: 7999,
    rating: 4.5,
    size: "200ml",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16167882/2021/11/27/25c0c64c-21a5-420b-91a9-1ed395acf24f1637990414359MACSetofLipstick-EyelinerPrepPrimeFix1.jpg",
    category: "Beauty",
    trending: false,
    reviews: 1200,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Forest Essentials",
    description:
      "Advanced Eternal Youth Formula Date & Litchi Anti Aging Night Cream 50g    ",
    price: 4950,
    original_price: 6599,
    rating: 4.5,
    size: "50g",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/12529686/2021/8/11/a87f5e32-d32b-44c5-8b0c-b6a2a20fc2261628671512447ForestEssentialsDateLitchiAdvancedEternalYouthFormula50g1.jpg",
    category: "Beauty",
    trending: false,
    reviews: 790,
    in_stock: true,
    delivery_time: "4-6 business days",
  },
  {
    _id: uuid(),
    title: "Mamaearth",
    description: "Unisex Bye Bye Dark Circles Sustainable Eye Cream 20g",
    price: 379,
    original_price: 549,
    rating: 4.2,
    size: "20ml",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/11265056/2021/8/11/e0e087d6-2d53-4cd1-8c36-43dbf46bc4201628659113889MamaearthUnisexByeByeDarkCirclesSustainableEyeCream20g1.jpg",
    category: "Beauty",
    trending: true,
    reviews: 6000,
    in_stock: true,
    delivery_time: "1-2 business days",
  },
  {
    _id: uuid(),
    title: "MCaffeine",
    description:
      "Sustainable Exfoliating Coffee Body Scrub for Tan Removal & Soft-Smooth Skin 100g",

    price: 395,
    original_price: 499,
    rating: 4.5,
    size: "100gm",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/10901940/2022/8/4/ecbeb48e-81aa-4355-b9ff-2e693dc80d4c1659620716962-MCaffeine-Sustainable-Exfoliating-Coffee-Body-Scrub-for-Tan--12.jpg",
    category: "Beauty",
    trending: false,
    reviews: 22800,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Mamaearth",
    description:
      "Sustainable Onion Hair Fall Control Shampoo With Onion & Plant Keratin 600ml ",
    price: 674,
    original_price: 899,
    rating: 4.2,
    size: "600ml",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/11081544/2022/3/27/0a61e786-c4f9-4cde-aa0e-1499fcb026971648366288580-Mamaearth-Sustainable-Onion-Hair-Fall-Control-Shampoo-With-O-11.jpg",
    category: "Beauty",
    trending: true,
    reviews: 13400,
    in_stock: true,
    delivery_time: "2-3 business days",
  },
  {
    _id: uuid(),
    title: "Chopard",
    description: "Men Chopard Black Incense Malaki Eau de Parfum + Deo Stick ",
    price: 11875,
    original_price: 13999,
    rating: 4.2,
    size: "200ml",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19554828/2022/8/18/aa5f8938-66b1-4538-9cd2-b8bb701075601660829421740ChopardBlackIncenseMalakiGiftSetEaudeParfum80mlDeoStick75ml1.jpg",
    category: "Beauty",
    trending: true,
    reviews: 1200,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
  {
    _id: uuid(),
    title: "Armaf",
    description: "Men Hunter Intense Eau De Toilette - 100 ml    ",
    price: 2116,
    original_price: 2499,
    rating: 4.1,
    size: "100ml",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16653990/2022/8/4/80da13a5-08f7-495d-9405-0bc68bfddac61659630632126ArmafMenHunterIntenseEauDeToilette-100ml2.jpg",
    category: "Beauty",
    trending: true,
    reviews: 200,
    in_stock: true,
    delivery_time: "3-5 business days",
  },
  {
    _id: uuid(),
    title: "Carlton London    ",
    description: "Women Limited Edition Blush Eau de Parfum- 100ml",
    price: 766,
    original_price: 999,
    rating: 4.2,
    size: "100ml",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/15455762/2023/2/2/4f476ad7-48bf-44ff-90c1-b7417c4152f11675318541550-Carlton-London-Women-Limited-Edition-Blush-Eau-de-Parfum--10-1.jpg",
    category: "Beauty",
    trending: false,
    reviews: 420,
    in_stock: true,
    delivery_time: "2-4 business days",
  },
];
